var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.60254C1.65482 2.60254 1.375 2.32272 1.375 1.97754C1.375 1.63236 1.65482 1.35254 2 1.35254C2.34518 1.35254 2.625 1.63236 2.625 1.97754C2.625 2.32272 2.34518 2.60254 2 2.60254Z",
    stroke: "#3F3F46",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.60254C1.65482 7.60254 1.375 7.32272 1.375 6.97754C1.375 6.63236 1.65482 6.35254 2 6.35254C2.34518 6.35254 2.625 6.63236 2.625 6.97754C2.625 7.32272 2.34518 7.60254 2 7.60254Z",
    stroke: "#3F3F46",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.6025C1.65482 12.6025 1.375 12.3227 1.375 11.9775C1.375 11.6324 1.65482 11.3525 2 11.3525C2.34518 11.3525 2.625 11.6324 2.625 11.9775C2.625 12.3227 2.34518 12.6025 2 12.6025Z",
    stroke: "#3F3F46",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsIcon);
export default __webpack_public_path__ + "static/media/three-dots-icon.4aebeb059b8d3ba71c61197e23cb4451.svg";
export { ForwardRef as ReactComponent };